export const MOBILE_HEADER_HEIGHT = 73;
export const DESKTOP_HEADER_HEIGHT = 88;
